import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CircularProgress from '@mui/material/CircularProgress';
import { SessionLimiterStrong } from '../../components/shared/Divider';
import { ViewContent } from '../../layout/Main/styled';
import { IJourneyResp, useGetJourneyByIdMutation } from '../../services/journey.service';
import { saveCurrentJourney } from '../../features/journey';
import PaymentInfo from '../../components/pages/Journey/PaymentInfo';
import PatientCare from '../../components/pages/Journey/InformationAbout/PatientCare';
import { useLocation, useNavigate } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import Calendar from '../../components/shared/Calendar';
import { RootState } from '../../store';
import JourneyActionManager from '../../components/shared/JourneyActionManager';
import IconButton from '@mui/material/IconButton';
import Grid from '@mui/material/Grid';
import { refreshSchedule } from '../../features/schedule/schedule-slice';
import TemplateDefault from '../../layout/TemplateDefault';
import Schedules from '../../components/pages/Journey/Schedules';
import ScheduleTreatment from '../../components/shared/ScheduleTreatment';

const Journey = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname;
  const {
    schedule: {
      confirm: confirmSchedule,
      haveToAnswerAnamnese,
      sendExams,
      ui: { backToTop }
    },
    journey,
    journey: { scheduleTreatments }
  } = useSelector((state: RootState) => state);
  const [getJourneyById, { data, isLoading }] = useGetJourneyByIdMutation();

  const loadJourneyData = () => {
    const url = path.split('/')[2];
    getJourneyById({ journeyId: url })
      .unwrap()
      .then((journey: IJourneyResp) => {
        dispatch(refreshSchedule());
        dispatch(saveCurrentJourney(journey));
      })
      .catch((error: any) => {
        console.log(error);
      });
  };

  useEffect(() => {
    loadJourneyData();
  }, []);

  useEffect(() => {
    if (confirmSchedule || haveToAnswerAnamnese || sendExams) loadJourneyData();
  }, [confirmSchedule, haveToAnswerAnamnese, sendExams]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [backToTop]);

  return (
    <>
      <TemplateDefault>
        <ViewContent className="ViewContent">
          <Grid container>
            <Grid item xs={0} sm={1} md={3}></Grid>
            <Grid item xs={12} sm={10} md={6}>
              <IconButton
                sx={{ width: 48, height: 48, backgroundColor: 'neutrals.beige3', mb: 4 }}
                onClick={() => navigate(-1)}
              >
                <ArrowBackIcon />
              </IconButton>

              <Typography mb={3} variant="h3">
                {data?.product?.alias ? data.product.alias : data?.product?.name}
              </Typography>
              {!isLoading ? <></> : <CircularProgress sx={{ color: 'brand.darkGreen' }} />}
              <JourneyActionManager variant="current" />
              <Schedules journey={journey} />

              {scheduleTreatments?.length > 0 ? (
                <>
                  <SessionLimiterStrong />
                  <ScheduleTreatment scheduleTreatments={scheduleTreatments} />
                </>
              ) : null}

              <PaymentInfo />
              <SessionLimiterStrong />
              <PatientCare />
              <Calendar />
            </Grid>
            <Grid item xs={0} sm={1} md={3}></Grid>
          </Grid>
        </ViewContent>
      </TemplateDefault>
    </>
  );
};

export default Journey;
